<swiper #swiper
        [pagination]="pagination"
        [initialSlide]="initialSlideIndex"
        [slidesPerView]="slidesPerView"
        [speed]="transitionDurationInMs"
        [preloadImages]="!lazyLoadImages"
        [enabled]="!disabled"
        [zoom]="false"
        (init)="broadcastDidLoad()"
        (slideChangeTransitionStart)="broadcastWillChange()"
        (slideChangeTransitionEnd)="broadcastActiveIndex($event)">
    <ng-template *ngFor="let slide of contents" swiperSlide>
        <!-- We cannot use ng-content as it does not work applies at component level and not at template level-->
        <ng-template [ngTemplateOutlet]="slide.template"
                     [ngTemplateOutletContext]="{$implicit: slide.template}"></ng-template>
    </ng-template>
</swiper>
